import React, { useState } from 'react';
import { useContext } from 'react';
import MessagesContext from '../../../contexts/messagesContext';
import { MainDialog, SubmitButton } from '../../UI';
import { PropTypes } from 'prop-types';
import { FileIcon } from '../../UI/Images/Icons';
import RadioButton from '../../UI/inputs/RadioButton';
import { makeStyles } from '@material-ui/core';
import SelectionClinic from '../../AdvancedSearch/Result/resultHeader/selectionClinic';

export const styles = makeStyles({
    reportButton: {
        padding: '5px 3px',
        borderRadius: '6px',
        border: 'solid 1.5px #416ce1',
        backgroundColor: '#fff',
        fontFamily: 'inherit',
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: 1.75,
        textAlign: 'center',
        color: '#416ce1',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#e7ecf2'
        },
        '&:disabled': {
            backgroundColor: '#fff',
            opacity: '0.5',
            color: '#416ce1'
        }
    },
    createReport: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'start',
        paddingBottom: '10px',
        '& > *': {
            fontSize: '13px'
        }
    },
    radioWrapper: {
        display: 'flex',
        marginInlineStart: '-10px',
        '& label': {
            margin: '0'
        }
    },
    button: {
        alignSelf: 'flex-end'
    },
    errorMessage: {
        color: 'red',
        margin: '5px 0 ',
        visibility: ({ isInvalid }) => (isInvalid ? 'visible' : 'hidden')
    }
});
const CreateReport = ({ handleCreateReport, isLoading, isSearch = false, form }) => {
    const [isInvalid, setIsInvalid] = useState('');
    const { messages } = useContext(MessagesContext);
    const [openMenu, setOpenMenu] = useState(false);
    const classes = styles({ isInvalid });
    const [value, setValue] = useState({
        choice_repr: 'label',
        headers: 'labels',
        flat: 'true',
        clinic: null
    });
    const options = {
        choice: [
            {
                value: 'label',
                label: messages.title
            },
            { value: 'id', label: messages.identifier }
        ],
        header: [
            {
                value: 'labels',
                label: messages.title
            },
            { value: 'keys', label: messages.key }
        ],
        flat: [
            { value: 'true', label: messages.yes },
            { value: 'false', label: messages.no }
        ]
    };

    const handleHeader = ({ target: { value } }) => {
        setValue((prev) => ({ ...prev, headers: value }));
    };
    const handleChoice = ({ target: { value } }) => {
        setValue((prev) => ({ ...prev, choice_repr: value }));
    };
    const handleFlat = ({ target: { value } }) => {
        setValue((prev) => ({ ...prev, flat: value }));
    };
    const handleSelectClinic = (value) => {
        if (value) setIsInvalid(false);
        setValue((prev) => ({ ...prev, clinic: value.id }));
    };

    const handleReport = () => {
        handleCreateReport(value);
        setOpenMenu(false);
    };

    const onSubmit = () => {
        if (isSearch) return handleReport();
        else if (value.clinic) {
            handleReport();
            setIsInvalid(false);
        } else {
            setIsInvalid(true);
        }
    };
    return (
        <div>
            <button
                className={classes.reportButton}
                data-testid="createReport"
                disabled={isLoading || form?.export_status === 'D'}
                onClick={() => setOpenMenu(true)}
            >
                <FileIcon />
                {isLoading || form?.export_status === 'D'
                    ? messages.loadingMessage + '...'
                    : form?.export_status === 'G' && !isSearch
                    ? messages.reCreateReport
                    : form?.export_status === 'G' && isSearch
                    ? messages.createReport
                    : form?.export_status === 'E'
                    ? messages.createReport
                    : messages.createReport}
            </button>
            <MainDialog open={openMenu} goBack={() => setOpenMenu(false)} minHeight="200px">
                <div className={classes.createReport}>
                    {!isSearch && (
                        <>
                            <span>{messages.exportFromClinics}</span>
                            <SelectionClinic handleSelectClinic={handleSelectClinic} />
                            <span className={classes.errorMessage}>
                                {messages.validations.required}
                            </span>
                        </>
                    )}
                    <span>{messages.viewHeaderWith}:</span>
                    <div className={classes.radioWrapper}>
                        {options.header.map((item, index) => (
                            <RadioButton
                                key={index}
                                label={item.label}
                                value={item.value}
                                groupValue={value.headers}
                                handleChange={handleHeader}
                            />
                        ))}
                    </div>
                    <span>{messages.viewMultipleWith}:</span>
                    <div className={classes.radioWrapper}>
                        {options.choice.map((item, index) => (
                            <RadioButton
                                key={index}
                                label={item.label}
                                value={item.value}
                                groupValue={value.choice_repr}
                                handleChange={handleChoice}
                            />
                        ))}
                    </div>
                    <span>{messages.flatSelect}:</span>
                    <div className={classes.radioWrapper}>
                        {options.flat.map((item, index) => (
                            <RadioButton
                                key={index}
                                label={item.label}
                                value={item.value}
                                groupValue={value.flat}
                                handleChange={handleFlat}
                            />
                        ))}
                    </div>
                    <SubmitButton
                        submitText={messages.createReport}
                        className={classes.button}
                        isButton
                        width="140"
                        height="30px"
                        mt={'15px'}
                        disableSubmit
                        handleClick={onSubmit}
                    />
                </div>
            </MainDialog>
        </div>
    );
};
CreateReport.propTypes = {
    handleCreateReport: PropTypes.function,
    isLoading: PropTypes.bool,
    isSearch: PropTypes.bool,
    form: PropTypes.object
};
export default CreateReport;
